module.exports = __webpack_public_path__ + "media/images/proof_links/colored/meetup-d555a9dd147048f710e779d85f384512.svg";